import $ from 'jquery';
import ApplicationController from './application_controller';

/*
 * Co-signature Request Row Controller
 *
 * One manual co-signature request row in the co-signature modal
 * (app/views/signature_requests/_signature_request_fields.html.erb).
 *
 * "Use for billing" makes the co-signer the rendering provider on the claim, so SignatureRequest only accepts it
 * for a fully licensed co-signer. Rather than let the author submit, fail, and lose every row in the modal, this
 * unticks and disables the checkbox as soon as an assistant is picked. The server validation stays the backstop.
 *
 * The select is Selectize, which reports a pick by triggering a jQuery change on the original <select>, and native
 * listeners miss those. The listener is bound with jQuery, which also receives native change events for rows that
 * are not enhanced. Eligibility comes from the ids value rather than from <option> data attributes, because
 * Selectize rebuilds the options and drops their attributes.
 */
export default class extends ApplicationController {
  static targets = ['select', 'billing'];

  static values = { billingEligibleIds: Array };

  connect() {
    if (!this.hasSelectTarget) return;

    $(this.selectTarget).on('change.coSignatureRequestRow', () => this.sync());
    this.sync();
  }

  disconnect() {
    if (this.hasSelectTarget) $(this.selectTarget).off('change.coSignatureRequestRow');
  }

  sync() {
    if (!this.hasBillingTarget) return;

    const selected = this.selectTarget.value;
    // Nobody picked yet: leave it usable. The select is required, so a blank row cannot be submitted.
    const eligible = selected === '' || this.billingEligibleIdsValue.includes(selected);

    if (!eligible) this.billingTarget.checked = false;
    this.billingTarget.disabled = !eligible;
  }
}
